module.exports = __webpack_public_path__ + "img/hypergryph&montagne_white.0df5878e.svg";